import moment from 'moment';
import * as queryString from 'query-string';
import urljoin from 'url-join';
import srcset from 'srcset';
import config from '../../config';
import { paths } from '../../constants';

/* eslint no-param-reassign: ["error", { "props": false }] */

export function urlIsAbsolute(url) {
    const regex = /^https?:\/\//;
    const startsWithHttpOrHttps = regex.test(url);
    return startsWithHttpOrHttps;
}

export function formatUrlForCdn(cdnUrl, urlPath) {
    // urls that start with /v*/ need to have that stripped off, other urls need to be prefixed with the public path
    if (!urlIsAbsolute(urlPath)) {
        const regex = /^\/v(0?[1-9]|[1-9][0-9])\//;
        const isApiSource = regex.test(urlPath);

        if (isApiSource) {
            return urljoin(cdnUrl || '', urlPath);
        }

        return urljoin(config.publicPath, urlPath);
    }

    return urlPath;
}

export function updateSrcSetForCdn(srcSet, cdnUrl) {
    const parsedSrcSet = srcset.parse(srcSet);
    parsedSrcSet.forEach((src) => {
        src.url = formatUrlForCdn(cdnUrl, src.url);
    });
    return srcset.stringify(parsedSrcSet);
}
export function parseUrlParam(url, param) {
    const parsed = queryString.parse(url);
    if (param in parsed) {
        return parsed[param];
    }
    return '';
}

export const buildPathWithQueryParams = (basePath, queryParams) => {
    const queryStringPart = Object.keys(queryParams).length > 0
        ? `?${queryString.stringify(queryParams, { encode: false })}`
        : '';
    return `${basePath}${queryStringPart}`;
};

export const constructRedirectPath = (currentPath, targetPath, queryParams, isReturnParam = true) => {
    const queryStringPart = Object.keys(queryParams).length > 0
        ? `?${queryString.stringify(queryParams, { encode: true })}`
        : '';
    let constructedPath;

    if (currentPath === paths.login || currentPath === paths.join || currentPath === '/') {
        constructedPath = `${targetPath}${queryStringPart}`;
    } else {
        const encodedRedirectUrl = encodeURIComponent(`${currentPath}${queryStringPart}`);
        constructedPath = `${targetPath}?${isReturnParam ? 'return' : 'next'}=${encodedRedirectUrl}`;
    }

    return constructedPath;
};

export const getNavigationParameter = (parsedInput) => {
    if (!parsedInput) {
        return null;
    }

    let navigationParam;

    if (parsedInput.next) {
        navigationParam = 'next';
    } else if (parsedInput.return) {
        navigationParam = 'return';
    } else if (parsedInput.redirect) {
        navigationParam = 'redirect';
    } else {
        navigationParam = null;
    }

    return navigationParam;
};

const HOTEL_PLANNER_BASE_URL = 'https://utrsports.hotelplanner.com/search/';

export const buildHotelPlannerUrl = (event, { custom4, custom5 } = {}) => {
    const location = event?.eventLocations?.[0];
    const schedule = event?.eventSchedule;
    const params = [];

    if (location) {
        const hasCityOrStreet = location.placeName || location.streetAddress || location.cityName;
        const cityValue = hasCityOrStreet
            ? [location.placeName, location.streetAddress, location.cityStateZip].filter(Boolean).join(' ')
            : location.googleFormattedName;
        if (cityValue) {
            const city = cityValue.replace(/,/g, '').replace(/\s+/g, '+');
            params.push(`city=${city}`);
        }
    }

    if (schedule?.eventStartUtc) {
        params.push(`InDate=${moment.utc(schedule.eventStartUtc).format('MM/DD/YYYY')}`);
    }
    if (schedule?.eventEndUtc) {
        params.push(`OutDate=${moment.utc(schedule.eventEndUtc).format('MM/DD/YYYY')}`);
    }

    if (custom4) {
        params.push(`custom4=${encodeURIComponent(custom4)}`);
    }
    if (custom5) {
        params.push(`custom5=${encodeURIComponent(custom5)}`);
    }

    return params.length ? `${HOTEL_PLANNER_BASE_URL}?${params.join('&')}` : '';
};
